import { Button, Heading, Flex, useColorMode } from '@chakra-ui/react';
import ActionMenu from '../ActionMenu';
import BotConnector from '../BotConnector';
import { FaPhone, FaPlus, FaSave } from 'react-icons/fa';
import { useAssistant } from "../../context/AssistantContext";

const RightPanelHeader = ({ handleOpen }) => {
    const { selectedAssistant, handleSubmit, onNewAssistant, setIsDialogOpen, onDuplicate, handleNewAssistant } = useAssistant();
    const { colorMode } = useColorMode();
    return (
        <Flex justifyContent="space-between" alignItems="center" mb={4} direction={{
            base: "column",
            md: "row",
            lg: "row"
        }}>
            {selectedAssistant && (
                <Heading size="md" color={colorMode === 'light' ? 'gray.800' : 'white'}>Assistant - Configuration</Heading>
            )}
            <Flex direction={{
                base: "column",
                md: "column",
                lg: "row"
            }} gap={{
                base: 1,
                md: 1,
                lg: 1
            }}>
                {selectedAssistant && (
                    <BotConnector
                        assistantId={selectedAssistant._id}
                    />
                )}
                {selectedAssistant && (
                    <Button
                        rightIcon={<FaPhone />}
                        colorScheme="yellow"
                        onClick={handleOpen}
                        disabled={!!selectedAssistant.newAssistant}
                    >
                        Call Me
                    </Button>
                )}

                <Button
                    leftIcon={<FaPlus />}
                    colorScheme="teal"
                    onClick={handleNewAssistant}>
                    New Assistant
                </Button>
                {selectedAssistant && (
                    <Button
                        leftIcon={<FaSave />}
                        onClick={handleSubmit}>
                        Save Changes
                    </Button>
                )}
                <ActionMenu
                    onDuplicate={onDuplicate}
                    onDelete={() => setIsDialogOpen(true)}
                />
            </Flex>
        </Flex>
    );
};

export default RightPanelHeader;